import { useParams, Outlet } from 'react-router-dom';
import Stack from '@mui/joy/Stack';

import IdentityAvatar from 'components/IdentityAvatar';

const IdentityContainer = () => {
    const { identityKey } = useParams<{identityKey: string}>();
    return (
        <Stack>
            <Stack
                direction="row"
                justifyContent="space-between"

                sx={{
                        left: 0,
                        display: 'flex',
                        zIndex: 800,
                   }}
                py={1}
            >
                <Stack
                    direction="row"

                    spacing={1}
                    mx={2}
                    width="100%"
                    alignItems="center">


                    <IdentityAvatar
                        size="inline"
                        interactive="link"
                        identityKey={identityKey} />

                </Stack>
            </Stack>


                <Outlet />

        </Stack>
    );
}
export default IdentityContainer;
